import React from 'react';
import {
  Box,
  Flex,
  ShowInLargeUp,
  ShowInMediumDown,
} from './../components/layout/Grid';
import BaseSkeleton from './../skeletons/BaseSkeleton';

const VideosGenresTaxonomiesSkeleton = () => (
  <React.Fragment>
    <Box as={ShowInMediumDown}>
      <Box mb="20px">
        <BaseSkeleton shape="square" height={20} width={100} />
      </Box>
    </Box>
    <Box as={ShowInLargeUp}>
      <Flex mb="20px" justifyContent="space-between" alignItems="center">
        <BaseSkeleton shape="square" height={20} width={35} />
        <BaseSkeleton shape="square" height={20} width={10} />
      </Flex>
    </Box>
  </React.Fragment>
);

export default VideosGenresTaxonomiesSkeleton;
